import React, { useState, useEffect } from 'react';
import { apiGet, apiPost } from '../api';

const unbanUser = (payload) => apiPost('/api/admin/unban-user', payload);

const BlockList = () => {
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [unbanningId, setUnbanningId] = useState(null);

    useEffect(() => {
        let alive = true;
        apiGet('/api/admin/blocklist')
            .then(list => { if (alive) { setBlockedUsers(list); setLoading(false); } })
            .catch(() => { if (alive) { setError("Failed to load data. Please try again."); setLoading(false); } });
        return () => { alive = false; };
    }, []);

    const handleUnban = async (userId) => {
        if (!window.confirm("Are you sure you want to unban this user and their device?")) return;
        setUnbanningId(userId);
        try {
            const result = await unbanUser({ userId });
            if (result.success === false) throw new Error(result.message);
            alert(result.message);
            setBlockedUsers(prev => prev.filter(u => u.id !== userId));
        } catch (err) {
            alert(`Error: ${err.message}`);
        } finally {
            setUnbanningId(null);
        }
    };

    if (loading) return <div className="dark-loading"><div className="spinner" /><p>Loading Blocked Users...</p></div>;
    if (error) return <div className="dark-error">{error}</div>;

    return (
        <div className="dark-page">
            <h2>Blocked & Disabled Users</h2>

            {blockedUsers.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px 20px', color: 'rgba(255,255,255,0.4)' }}>
                    <i className="fas fa-check-circle" style={{ fontSize: 40, marginBottom: 12, display: 'block', color: '#4ade80' }} />
                    No users are currently blocked or disabled.
                </div>
            ) : (
                <div className="dark-table-wrap">
                    <table className="dark-table">
                        <thead>
                            <tr>
                                <th>Username / Email</th>
                                <th>User ID</th>
                                <th>Block Type</th>
                                <th>Reason</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {blockedUsers.map(user => (
                                <tr key={user.id}>
                                    <td className="font-medium">{user.displayName || user.email || 'N/A'}</td>
                                    <td style={{ fontFamily: 'monospace', fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>{user.id}</td>
                                    <td>
                                        <span className={`badge ${user.blockType.includes('Device') ? 'badge-red' : 'badge-yellow'}`}>
                                            {user.blockType}
                                        </span>
                                    </td>
                                    <td className="text-muted">{user.reason || 'N/A'}</td>
                                    <td className="text-center">
                                        <button
                                            onClick={() => handleUnban(user.id)}
                                            disabled={unbanningId === user.id}
                                            className="btn-action"
                                            style={{
                                                background: 'rgba(34,197,94,0.15)', color: '#4ade80',
                                                border: '1px solid rgba(34,197,94,0.3)',
                                                padding: '6px 14px', fontSize: 12
                                            }}
                                        >
                                            {unbanningId === user.id
                                                ? <><i className="fas fa-spinner fa-spin" /> Processing...</>
                                                : <><i className="fas fa-unlock" /> Unblock</>
                                            }
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default BlockList;
